import logo from './assets/images/logo.png';
import './App.css';
import React, { useState, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom';
import '../src/assets/css/Style.css'
import jwt_decode from "jwt-decode";
import Login from './Screens/Login';
import isEmpty from "is-empty";
// lib
import { getAuthToken } from "./lib/localStorage";
// import constant
import { SET_AUTHENTICATION } from "./constant";
import { useDispatch } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { PrivateRoute } from './PrivateRoutes';

import Dashboard from './views/Dashboard/Dashboard.js'
import TokenList from './views/Token/TokenList.js'
import UsersList from './views/Users/UsersList.js'
import CategoryList from './views/Category/CategoryList.js'
import FAQList from './views/Faq/FAQList.js'
import SubscriberList from './views/Subscriber/SubscriberList.js'
import PurchaseList from './views/Purchase/PurchaseList.js';
import ReportList from './views/Report/ReportList.js';
import NFTList from './views/NFTTag/NFTList.js';
import SocialLinks from './views/UserProfile/UserSettings.js';
import Domains from './views/Domains/Domains.js';
import SBT from './views/SbtTokens/TokenList.js'
import BulkCollection from './views/Collection/TokenList.js'
import CategoryListSoul from './views/CategorySoul/CategoryList.js'
import AddCategorySoul from "./views/CategorySoul/AddCategory.js";
import EditCategorySoul from './views/CategorySoul/EditCategory.js'
import CategoryListFractional from './views/FractionalCategory/CategoryList.js'
import EditCategoryFractional from './views/FractionalCategory/EditCategory.js'
import AddCategoryFractional from './views/FractionalCategory/AddCategory.js'
import UserProfile from './views/UserProfile/UserProfile.js';
import PlannedUser from './views/PlannedUser/PlannedUser.js';
import Subscriptionadd from "./views/SubscriptionPlan/Subscriptionadd.js"
import ViewToken from './views/Token/ViewToken.js';
import UserAdd from './views/Users/UserAdd.js';
import UserEdit from './views/Users/UsersEdit.js';
import AddCategory from './views/Category/AddCategory.js';
import EditCategory from './views/Category/EditCategory.js';
import FAQEdit from './views/Faq/FAQEdit.js';
import FAQAdd from './views/Faq/FAQAdd.js';
import SubscriberAdd from './views/Subscriber/SubscriberAdd.js';
import AddNFT from './views/NFTTag/AddNFT.js';
import ViewSBT from './views/SbtTokens/ViewCollection.js';
import ViewCollection from './views/Collection/ViewCollection.js';
import BidTokenList from './views/BpxToken/bpxlist.js'
import BidToken from './views/BpxToken/AddToken.js'
import MIDCMSLIST from "./views/CmsNew/CmsNewList.js"
import MIDCMSEDIT from "./views/CmsNew/CmsNewadd";
import CMSLIST from "./views/MidCMS/MidNewList";
import CMSEDIT from "./views/MidCMS/MidNewedit";
import EditServiceFee from './views/ServiceFee/EditServiceFee.js'
import EditServiceFeeFraction from './views/ServiceFeeFractional/EditFee.js'
import Reveue from './views/RevenueShare/Revenue.js'
import SubAdmin from './views/SubAdmin/ChangeSubAdmin.js'

function App() {
  const dispatch = useDispatch()
  useEffect(() => {

    let token = getAuthToken();
    if (!isEmpty(token)) {
      token = token.replace("Bearer ", "");
      const decoded = jwt_decode(token);
      if (decoded) {
        dispatch({
          type: SET_AUTHENTICATION,
          authData: {
            isAuth: true,
            userId: decoded._id,
            restriction: decoded.restriction,
            role: decoded.role,
            email: decoded.email,
            name: decoded.name
          },
        });
      }
    }

  }, [])

  return (
    <>
      <Toaster />
      <Routes>
        <Route path='/' element={
            <Login />
        } />


        <Route exact path='/dashboard' element={<PrivateRoute >
          <Dashboard />
        </PrivateRoute>        
        } />

        <Route exact path='/tokenList' element={<PrivateRoute >
          <TokenList />
        </PrivateRoute >
        } />

        <Route exact path='/viewToken/:Owner/:Id' element={<PrivateRoute >
          <ViewToken />
        </PrivateRoute >
        } />

        <Route exact path='/userList' element={<PrivateRoute >
          <UsersList />
        </PrivateRoute >
        } />

        <Route exact path='/UserAdd' element={<PrivateRoute >
          <UserAdd />
        </PrivateRoute >
        } />

        <Route exact path='/UserEdit' element={<PrivateRoute >
          <UserEdit />
        </PrivateRoute >
        } />

        <Route exact path='/categorylist' element={<PrivateRoute >
          <CategoryList />
        </PrivateRoute >
        } />

        <Route exact path='/AddCategory' element={<PrivateRoute >
          <AddCategory />
        </PrivateRoute >
        } /> 

        <Route exact path='/EditCategory/:userId' element={<PrivateRoute >
          <EditCategory />
        </PrivateRoute >
        } /> 

        <Route exact path='/faqList' element={<PrivateRoute >
          <FAQList />
        </PrivateRoute >
        } />

        <Route exact path='/faqedit/:faqId' element={<PrivateRoute >
          <FAQEdit />
        </PrivateRoute >
        } />

        <Route exact path='/faqadd' element={<PrivateRoute >
          <FAQAdd />
        </PrivateRoute >
        } />

        <Route exact path='/subscriberlist' element={<PrivateRoute >
          <SubscriberList />
        </PrivateRoute >
        } />

        <Route exact path='/subscriberadd' element={<PrivateRoute >
          <SubscriberAdd />
        </PrivateRoute >
        } />

        <Route exact path='/purchasedlist' element={<PrivateRoute >
          <PurchaseList />
        </PrivateRoute >
        } />

        <Route exact path='/reportlist' element={<PrivateRoute >
          <ReportList />
        </PrivateRoute >
        } />

        <Route exact path='/nfttag' element={<PrivateRoute >
          <NFTList />
        </PrivateRoute >
        } />

        <Route exact path='/editnft/:id' element={<PrivateRoute >
          <AddNFT />
        </PrivateRoute >
        } />

        <Route exact path='/settings' element={<PrivateRoute >
          <SocialLinks />
        </PrivateRoute >
        } />

        <Route exact path='/editserviceFee' element={<PrivateRoute >
          <EditServiceFee />
        </PrivateRoute >
        } />

        <Route exact path='/editserviceFraction' element={<PrivateRoute >
          <EditServiceFeeFraction />
        </PrivateRoute >
        } />

        <Route exact path='/Domains' element={<PrivateRoute >
          <Domains />
        </PrivateRoute >
        } />

        <Route exact path='/SBT' element={<PrivateRoute >
          <SBT />
        </PrivateRoute >
        } />

        <Route exact path='/ViewCollection/:Owner/:Id' element={<PrivateRoute >
          <ViewSBT />
        </PrivateRoute >
        } />

        <Route exact path='/Collection' element={<PrivateRoute >
          <BulkCollection />
        </PrivateRoute >
        } />

        <Route exact path='/CollectionView/:Owner/:Id' element={<PrivateRoute >
          <ViewCollection />
        </PrivateRoute >
        } />

        <Route exact path='/categorylistSBT' element={<PrivateRoute >
          <CategoryListSoul />
        </PrivateRoute >
        } />

        <Route exact path="/EditCategorySBT/:userId" element={<PrivateRoute >
          <EditCategorySoul />
        </PrivateRoute >
        } />
        
        <Route exact path="/AddCategorySBT" element={<PrivateRoute >
          <AddCategorySoul />
        </PrivateRoute >
        } />

        <Route exact path='/categorylistFractional' element={<PrivateRoute >
          <CategoryListFractional />
        </PrivateRoute >
        } />

        <Route exact path='/EditCategoryFractional/:userId' element={<PrivateRoute >
          <EditCategoryFractional />
        </PrivateRoute >
        } />

        <Route exact path='/AddCategoryFractional' element={<PrivateRoute >
          <AddCategoryFractional />
        </PrivateRoute >
        } />

        <Route exact path='/ListCustomtoken' element={<PrivateRoute >
          <BidTokenList />
        </PrivateRoute >
        } />

        <Route exact path='/AddCustomToken' element={<PrivateRoute >
          <BidToken />
        </PrivateRoute >
        } />

        <Route exact path='/user' element={<PrivateRoute >
          <UserProfile />
        </PrivateRoute >
        } />

        <Route exact path='/plannedUser' element={<PrivateRoute >
          <PlannedUser />
        </PrivateRoute >
        } />

        <Route exact path='/subscriptionadd' element={<PrivateRoute >
          <Subscriptionadd />
        </PrivateRoute >
        } />

        <Route exact path='/cmslist' element={<PrivateRoute >
          <MIDCMSLIST />
        </PrivateRoute >
        } />

        <Route exact path='/midcmslist/:name' element={<PrivateRoute >
          <CMSLIST />
        </PrivateRoute >
        } />

        <Route exact path='/cmsedit/:Id' element={<PrivateRoute >
          <CMSEDIT />
        </PrivateRoute >
        } />

        <Route exact path='/Midcmslist/edit/:name' element={<PrivateRoute >
          <MIDCMSEDIT />
        </PrivateRoute >
        } />

        <Route exact path='/RevenueDetails' element={<PrivateRoute >
          <Reveue />
        </PrivateRoute >
        } />

<Route exact path='/changeContract' element={<PrivateRoute >
          <SubAdmin />
        </PrivateRoute >
        } />

      </Routes>
    </>
  );
}

export default App;